import React, { useEffect, useState } from "react";
import {
  Utensils,
  Hotel,
  GraduationCap,
  Stethoscope,
  Building2,
} from "lucide-react";
import useFetchPlaces from "@/helpers/useFetchPlaces";
import { GlobalData } from "@/app/context/GlobalContext";

export const categories = [
  { id: 1, label: "Restaurants", value: "restaurant", icon: Utensils },
  { id: 2, label: "Hotels", value: "hotel", icon: Hotel },
  { id: 3, label: "Schools", value: "school", icon: GraduationCap },
  { id: 4, label: "Hospitals", value: "hospital", icon: Stethoscope },
  { id: 5, label: "Banks", value: "bank", icon: Building2 },
];

const CategoriesButtonComponent = () => {
  const {
    selectedCategory,
    setSelectedCategory,
    searchQuery,
    selectedBusiness,
    setSearchQuery,
    fetchPlaces,
    setSelectedPlaceNavbar
  } = GlobalData();
  // const { fetchPlaces, isLoading } = useFetchPlaces();

  console.log("CATEGORYYYYYYYYYYYYY : ", selectedCategory)

  // useEffect(() => {
  //   console.log("CAT-------------------seled : ", selectedCategory);
  //   if (selectedCategory && !isApiLoading) {
  //     fetchPlaces(selectedCategory);
  //   }
  // }, [selectedCategory]);

  const handleCategoryClick = (category) => {
    console.log("CAT------------------- : ", category);
    setSelectedCategory(category === selectedCategory ? null : category);
    setSelectedPlaceNavbar(null);
    setSearchQuery("");
    if (category !== selectedCategory) {
      fetchPlaces(category);
    } else {
      fetchPlaces("restaurant, hotel, school, hospital, bank");
    }
  };

  return (
    // <div className="p-4 bg-white">
    <div className="flex gap-2 overflow-x-hidden pb-2 z-10">
      {categories.map((category) => {
        const Icon = category.icon;
        return (
          <button
            key={category.id + 1}
            onClick={() => handleCategoryClick(category.value)}
            className={`
                                flex items-center gap-2 px-4 py-2 rounded-full
                                whitespace-nowrap text-sm font-medium
                                transition-all duration-200 shadow-md 
                                ${selectedCategory === category.value ||
                selectedBusiness === category.value
                ? "bg-blue-500 text-white hover:bg-blue-700"
                : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300"
              }
                
                                    `}
          >
            <Icon size={16} />
            {category.label}
          </button>
        );
      })}
    </div>
    // </div>
  );
};

export default CategoriesButtonComponent;
